import { render } from "./OsTipoPagamentoSelect.vue?vue&type=template&id=0e3a94e3"
import script from "./OsTipoPagamentoSelect.vue?vue&type=script&lang=js"
export * from "./OsTipoPagamentoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__